var _style, _path, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBandcamp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bandcamp",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104.47 104.47",
    style: {
      enableBackground: "new 0 0 104.47 104.47"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st0",
    d: "M99,13.57c-1.14-3.94-4.17-6.97-8.11-8.11c-25.3-7.29-52.03-7.29-77.32,0 C9.63,6.6,6.6,9.63,5.47,13.57c-7.29,25.29-7.29,52.03,0,77.32c1.12,3.88,4.22,6.99,8.11,8.11c12.65,3.64,25.65,5.47,38.66,5.47 c13,0,26.01-1.82,38.66-5.47c3.88-1.12,6.99-4.22,8.11-8.11C106.29,65.6,106.29,38.86,99,13.57z M92.29,88.96 c-0.46,1.59-1.74,2.87-3.33,3.33c-24.03,6.92-49.43,6.92-73.46,0c-1.59-0.46-2.87-1.74-3.33-3.33c-6.92-24.03-6.92-49.43,0-73.46 c0.46-1.59,1.74-2.87,3.33-3.33c12.01-3.46,24.37-5.19,36.73-5.19c12.36,0,24.71,1.73,36.73,5.19c1.6,0.46,2.87,1.74,3.33,3.33 C99.22,39.53,99.22,64.93,92.29,88.96z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5_",
    className: "st0",
    points: "40.47,36.03 25.49,68.43 64,68.43 78.97,36.03 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandcamp);
export default __webpack_public_path__ + "static/media/bandcamp.b15cd6653eeaa4d133c9cfcab12a8114.svg";
export { ForwardRef as ReactComponent };